import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { sendAsync } from "../../../app/applicationSlice";
import { RootState, RootThunkApi } from "../../../app/store";
import { fromJson, PaymentResult } from "../../../models/paymentresult";
import { getPaymentResult as apiGetPaymentResult } from "../../../services/payment";

interface PaymentResultState {
  result?: PaymentResult;
}

const initialState = {} as PaymentResultState;

export const getPaymentResult = createAsyncThunk<
  PaymentResult,
  string,
  RootThunkApi<PaymentResult>
>("pay/getPaymentResultStatus", async (paymentId, api) => {
  return sendAsync(apiGetPaymentResult(paymentId), api).then((data) =>
    fromJson(data)
  );
});

const resultSlice = createSlice({
  name: "payment/result",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getPaymentResult.fulfilled, (state, action) => {
      state.result = action.payload;
    });
  },
});

export const selectResult = (state: RootState): PaymentResult | undefined =>
  state.result.result;

export default resultSlice.reducer;
